import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { TabletIncomingGoodsReceiptsContainer } from "@/screens/Tablet/WarehouseReceiving/Incoming"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"

export const Route = createFileRoute("/app/tablet/warehouse-receiving/_layout/incoming")({
  validateSearch: zodValidator(
    createGoodsReceiptSearchSchema(GoodsReceiptSortField.EstimatedDeliveryDate, SortingOrder.Asc)
  ),
  component: TabletIncomingGoodsReceiptsContainer,
})
